import { render, staticRenderFns } from "./UpgradeUsage-Tile.vue?vue&type=template&id=1b2661a0&scoped=true&"
import script from "./UpgradeUsage-Tile.vue?vue&type=script&lang=js&"
export * from "./UpgradeUsage-Tile.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeUsage-Tile.vue?vue&type=style&index=0&id=1b2661a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2661a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VSpacer})
